<template>
  <div class="container">

    <div class="toolbar">
      <el-select v-model="platId" @change="mychange" placeholder="请选择" style="margin-right: 10px; width: 120px">
        <el-option
            v-for="item in musicStore.platInfoList"
            :key="item.id"
            :label="item.description"
            :value="item.id"
            :disabled="item.status === 0">
        </el-option>
      </el-select>
      <el-form :inline="true" :model="searchForm" class="search-form-inline" @submit.native.prevent>
        <el-form-item>
          <el-input v-model="searchForm.keyword" autofocus @keyup.enter.native="onSearch" placeholder="输入歌名或歌手"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="onSearch">搜索</el-button>
          <el-button type="success" :disabled="selection.length === 0" icon="el-icon-plus" @click="openCollectionDialog">添加到歌单</el-button>
        </el-form-item>
      </el-form>
      <!-- 当选中酷狗时，可以选择播放/下载的音质 -->
      <div v-if="platId === platIds.kugou">
        <span>音质：</span>
        <el-select v-model="kugouQualityPrefix" @change="mychange" placeholder="请选择" style="margin-right: 10px; width: 80px">
          <el-option
              v-for="item in kugouQualityOption"
              :key="item.value"
              :label="item.label"
              :value="item.value">
          </el-option>
        </el-select>
      </div>
    </div>
    <el-divider></el-divider>

    <!-- 由于不同接口返回数据不一致，所以需要写多个table -->
    <div class="table" v-if="platId === platIds.kuwo">
      <el-table
          :data="kuwoTableData"
          ref="kuwoTable"
          height="100%"
          highlight-current-row
          @row-dblclick="playFromKuwo"
          v-loading="searchLoading"
          key="kuwoTable"
          style="width: 100%" stripe  >
        <el-table-column
            type="selection"
            width="55">
        </el-table-column>
        <el-table-column
            prop="name"
            label="歌名"
            width="180">
        </el-table-column>
        <el-table-column
            prop="artist"
            label="歌手"
            width="180">
        </el-table-column>
        <el-table-column
            prop="album"
            label="专辑"
            width="300">
        </el-table-column>
        <el-table-column
            prop="songTimeMinutes"
            label="时长">
        </el-table-column>
        <el-table-column
            label="操作"
            width="250" fixed="right">
          <template slot-scope="scope">
            <!--播放-->
            <el-button @click="playFromKuwo(scope.row)" type="primary" title="播放" circle plain icon="el-icon-video-play" size="small"></el-button>
            <!--源链接-->
            <el-button @click="showSource(scope.row)" type="primary" title="源链接" circle plain icon="el-icon-position" size="small"></el-button>
            <!--下载-->
            <el-button @click="downloadFromKuwo(scope.row)" type="primary" title="下载" circle plain icon="el-icon-download" size="small"></el-button>
          </template>
        </el-table-column>
        <template slot="empty">
          <el-empty :image-size="200"></el-empty>
        </template>
      </el-table>
    </div>
    <div class="table" v-else-if="platId === platIds.kugou">
      <el-table
          :data="kugouTableData"
          height="100%"
          ref="kugouTable"
          key="kugouTable"
          @selection-change="handleSelectionChange"
          @row-dblclick="playFromKugou"
          v-loading="searchLoading"
          style="width: 100%;" stripe  >
        <el-table-column
            type="selection"
            width="40">
        </el-table-column>
        <el-table-column
            label="歌曲名"
            width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.OriSongName }}{{ scope.row.Suffix }}</span>
          </template>
        </el-table-column>
        <el-table-column
            prop="SingerName"
            label="歌手"
            width="180">
        </el-table-column>
        <el-table-column
            prop="AlbumName"
            label="专辑">
        </el-table-column>
        <el-table-column
            label="时长"
            width="180">
          <template slot-scope="scope">
            <!--保留两位小数-->
            {{parseInt(scope.row.Duration / 60)}}分{{scope.row.Duration%60}}秒
          </template>
        </el-table-column>
        <!--<el-table-column-->
        <!--    label="大小"-->
        <!--    width="100">-->
        <!--  <template slot-scope="scope">-->
        <!--    &lt;!&ndash;保留两位小数&ndash;&gt;-->
        <!--    {{(scope.row.FileSize / (1024*1024)).toFixed(2)}}MB-->
        <!--  </template>-->
        <!--</el-table-column>-->
        <el-table-column
            label="音质"
            width="220">
          <template slot-scope="scope">
            <el-tooltip placement="bottom">
              <div slot="content">普通音质<br/>{{ (scope.row.FileSize / (1024*1024)).toFixed(2) }}MB</div>
              <el-tag type="primary">普通</el-tag>
            </el-tooltip>
            <template v-if="scope.row.HQFileSize">
              <el-tooltip placement="bottom">
                <div slot="content">HQ音质<br/>{{ (scope.row.HQFileSize / (1024*1024)).toFixed(2) }}MB</div>
                <el-tag type="success">HQ</el-tag>
              </el-tooltip>
            </template>
            <template v-else-if="scope.row.SQFileSize">
              <el-tooltip placement="bottom">
                <div slot="content">SQ音质<br/>{{ (scope.row.SQFileSize / (1024*1024)).toFixed(2) }}MB</div>
                <el-tag type="warning">SQ</el-tag>
              </el-tooltip>
            </template>
            <template v-else-if="scope.row.ResFileSize">
              <el-tooltip placement="bottom">
                <div slot="content">Hi-Res音质<br/>{{ (scope.row.ResFileSize / (1024*1024)).toFixed(2) }}MB</div>
                <el-tag type="danger">Res</el-tag>
              </el-tooltip>
            </template>
          </template>
        </el-table-column>
        <el-table-column
            label="操作"
            width="150" fixed="right">
          <template slot-scope="scope">
            <!--播放-->
            <el-button @click="playFromKugou(scope.row)" type="primary" title="播放" circle plain icon="el-icon-video-play" size="small"></el-button>
            <!--添加到播放列表-->
            <el-button @click="addToPlayList(scope.row)" type="primary" title="添加到播放列表" circle plain icon="el-icon-plus" size="small"></el-button>
            <!--下载-->
            <el-button @click="downloadFromKugou(scope.row)" type="primary" title="下载" circle plain icon="el-icon-download" size="small"></el-button>
          </template>
        </el-table-column>
        <template slot="empty">
          <el-empty :image-size="200"></el-empty>
        </template>
      </el-table>
    </div>
    <div class="table" v-else-if="platId === platIds.bilibili">
      <!--<el-table-->
      <!--    :data="biliTableData"-->
      <!--    height="100%"-->
      <!--    ref="table"-->
      <!--    @selection-change="handleSelectionChange"-->
      <!--    highlight-current-row-->
      <!--    @row-dblclick="playFromKugou"-->
      <!--    v-loading="searchLoading"-->
      <!--    style="width: 100%;" stripe  >-->
      <!--  <el-table-column-->
      <!--      type="selection"-->
      <!--      width="55">-->
      <!--  </el-table-column>-->
      <!--  <el-table-column-->
      <!--      prop="SongName"-->
      <!--      label="歌曲名"-->
      <!--      width="180">-->
      <!--  </el-table-column>-->
      <!--  <el-table-column-->
      <!--      prop="SingerName"-->
      <!--      label="歌手"-->
      <!--      width="180">-->
      <!--  </el-table-column>-->
      <!--  <el-table-column-->
      <!--      prop="AlbumName"-->
      <!--      label="专辑">-->
      <!--  </el-table-column>-->
      <!--  <el-table-column-->
      <!--      label="时长"-->
      <!--      width="180">-->
      <!--    <template slot-scope="scope">-->
      <!--      &lt;!&ndash;保留两位小数&ndash;&gt;-->
      <!--      {{parseInt(scope.row.Duration / 60)}}分{{scope.row.Duration%60}}秒-->
      <!--    </template>-->
      <!--  </el-table-column>-->
      <!--  &lt;!&ndash;<el-table-column&ndash;&gt;-->
      <!--  &lt;!&ndash;    label="大小"&ndash;&gt;-->
      <!--  &lt;!&ndash;    width="100">&ndash;&gt;-->
      <!--  &lt;!&ndash;  <template slot-scope="scope">&ndash;&gt;-->
      <!--  &lt;!&ndash;    &lt;!&ndash;保留两位小数&ndash;&gt;&ndash;&gt;-->
      <!--  &lt;!&ndash;    {{(scope.row.FileSize / (1024*1024)).toFixed(2)}}MB&ndash;&gt;-->
      <!--  &lt;!&ndash;  </template>&ndash;&gt;-->
      <!--  &lt;!&ndash;</el-table-column>&ndash;&gt;-->
      <!--  <el-table-column-->
      <!--      label="音质"-->
      <!--      width="220">-->
      <!--    <template slot-scope="scope">-->
      <!--      <el-tooltip placement="bottom">-->
      <!--        <div slot="content">普通音质<br/>{{ (scope.row.FileSize / (1024*1024)).toFixed(2) }}MB</div>-->
      <!--        <el-tag type="primary">普通</el-tag>-->
      <!--      </el-tooltip>-->
      <!--      <template v-if="scope.row.HQFileSize">-->
      <!--        <el-tooltip placement="bottom">-->
      <!--          <div slot="content">HQ音质<br/>{{ (scope.row.HQFileSize / (1024*1024)).toFixed(2) }}MB</div>-->
      <!--          <el-tag type="success">HQ</el-tag>-->
      <!--        </el-tooltip>-->
      <!--      </template>-->
      <!--      <template v-if="scope.row.SQFileSize">-->
      <!--        <el-tooltip placement="bottom">-->
      <!--          <div slot="content">SQ音质<br/>{{ (scope.row.SQFileSize / (1024*1024)).toFixed(2) }}MB</div>-->
      <!--          <el-tag type="warning">SQ</el-tag>-->
      <!--        </el-tooltip>-->
      <!--      </template>-->
      <!--      <template v-if="scope.row.ResFileSize">-->
      <!--        <el-tooltip placement="bottom">-->
      <!--          <div slot="content">Hi-Res音质<br/>{{ (scope.row.ResFileSize / (1024*1024)).toFixed(2) }}MB</div>-->
      <!--          <el-tag type="danger">Res</el-tag>-->
      <!--        </el-tooltip>-->
      <!--      </template>-->
      <!--    </template>-->
      <!--  </el-table-column>-->
      <!--  <el-table-column-->
      <!--      label="操作"-->
      <!--      width="150" fixed="right">-->
      <!--    <template slot-scope="scope">-->
      <!--      &lt;!&ndash;播放&ndash;&gt;-->
      <!--      <el-button @click="playFromKugou(scope.row)" type="primary" title="播放" circle plain icon="el-icon-video-play" size="small"></el-button>-->
      <!--      &lt;!&ndash;源链接&ndash;&gt;-->
      <!--      &lt;!&ndash;<el-button @click="showSource(scope.row)" type="primary" title="源链接" circle plain icon="el-icon-position" size="small"></el-button>&ndash;&gt;-->
      <!--      &lt;!&ndash;下载&ndash;&gt;-->
      <!--      <el-button @click="downloadFromKugou(scope.row)" type="primary" title="下载" circle plain icon="el-icon-download" size="small"></el-button>-->
      <!--    </template>-->
      <!--  </el-table-column>-->
      <!--  <template slot="empty">-->
      <!--    <el-empty :image-size="200"></el-empty>-->
      <!--  </template>-->
      <!--</el-table>-->
    </div>

    <div class="table-footer" v-if="total">
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30, 50, 80, 100]"
          :page-size="pageSize"
          prev-text="上一页"
          next-text="下一页"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
      </el-pagination>
    </div>

    <!--be showed when download failed-->
    <el-drawer
        :visible.sync="dialogVisible"
        size="50%"
        :modal="false"
        direction="btt">
      <div class="playInfo">
        <el-image
            style="width: 100px; height: 100px" :src="albumUrl">
        </el-image>
        <span style="font-size: 20px">{{ playTitle }}</span>
        <!-- autoplay 自动播放 -->
        <!-- loop 循环播放 -->
        <!-- preload 用户点击播放才开始下载 -->
        <audio v-if="dialogVisible" :src="mp3Url" controls preload="none"></audio>
      </div>
    </el-drawer>

    <!-- add to collection dialog -->
    <el-dialog title="添加到歌单" :visible.sync="collectionDialogVisible"
               width="40%"
               top="20vh"
               v-if="collectionDialogVisible"
               @close="closeCollectionDialog"
    >
      <el-form v-loading="collectionLoading" :model="collectionForm" label-width="80px">
        <el-form-item style="margin-bottom: 22px" label="选择歌单">
          <el-select v-model="collectionForm.id" placeholder="请选择歌单" style="width: 320px">
            <el-option v-for="item in collectionOption"
                       :label="item.name"
                       :value="item.id"
                       :key="item.id"
            >
            </el-option>
            <el-option label="--创建歌单--" :value="-1" style="padding: 0"><el-button type="primary" style="width: 100%">创建歌单</el-button></el-option>
          </el-select>
        </el-form-item>
        <el-form-item style="margin-bottom: 22px" v-if="collectionForm.id === -1" label="歌单名称"
                      prop="name"
                      :rules="{ required: true, message: '歌单名称不能为空', trigger: 'blur' }"
        >
          <el-input v-model="collectionForm.name" autocomplete="off" style="width: 320px;"></el-input>
        </el-form-item>
        <el-form-item style="margin-bottom: 22px" v-if="collectionForm.id === -1" label="歌单描述"
                      prop="description"
        >
          <el-input v-model="collectionForm.description" autocomplete="off" style="width: 320px; margin-right: 20px"></el-input>
          <el-button type="primary" @click="createCollection">创建</el-button>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeCollectionDialog">取 消</el-button>
        <el-button type="primary" @click="submitAddToCollection">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ResponseCode from "../../constants/ResponseCode";
import {addCollection, addSongInfo, getCollection, searchMusic} from "../../api/music";
import {convertMusic} from "../../api/music";
import {download} from "../../util/download";
export default {
  name: "MusicSearch",
  data() {
    return {
      dialogVisible: false,
      kuwoTableData: [
        /*{
          // 歌曲id
          rid: ''
          // 歌名
          name: '',
          // 歌手
          artist: '',
          // 专辑
          album: '',
          时长
          songTimeMinutes: ''
        },*/
      ],
      kugouTableData: [],
      biliTableData: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      // 保存切换前的页码和页大小
      oldPage: 1,
      oldPageSize: 10,

      platId: 1,

      searchForm: {
        keyword: ''
      },
      searchLoading: false,
      audioId: '',
      // 音频地址
      mp3Url: '',
      // 专辑图片地址
      albumUrl: '',
      // 播放时的标题 = 歌曲名+歌手
      playTitle: '',
      lyrics: [],
      selection: [],
      // 歌单
      collectionDialogVisible: false,
      collectionLoading: false,
      // 这里要给一个初始值
      collectionForm: {id: -1},
      collectionOption:[],
      // 不同音质的前缀 for 酷狗
      kugouQualityOption: [
        {
          value: '',
          label: '普通'
        },
        {
          value: 'HQ',
          label: 'HQ'
        },
        {
          value: 'SQ',
          label: 'SQ'
        },
        {
          value: 'Res',
          name: 'Res'
        },
      ],
      kugouQualityPrefix: ''
    }
  },
  methods: {
    mychange() {
      // console.log(this.platId)
      // console.log(this.kugouQualityPrefix)
    },
    // 写多个onSearch方法，用来适配不同接口的返回值
    // 酷我搜索
    searchFromKuwo() {
      // 这里使用封装的axios，所以这里的/api不写
      searchMusic({
        'keyword':this.searchForm.keyword,
        'platId': this.platId,
        'pageNum': this.currentPage,
        'pageSize':this.pageSize
      }).then(res => {
        if (res.status !== ResponseCode.success) {
          this.$message.error('请求失败！'+res.statusText)
          this.searchLoading = false
          // 请求失败后同步备份
          this.currentPage = this.oldPage
          this.pageSize = this.oldPageSize
          return
        }
        if (res.data.code !== ResponseCode.success) {
          this.$message.error('数据源错误！'+ res.data.message)
          // 请求失败后同步备份
          this.currentPage = this.oldPage
          this.pageSize = this.oldPageSize
          this.searchLoading = false
          return
        }
        // this.$message.success('查询成功')
        this.$notify.success('查询成功')
        this.total = parseInt(res.data.data.total)
        this.kuwoTableData = res.data.data.list
        this.searchLoading = false
        // 请求成功后同步备份
        this.oldPage = this.currentPage
        this.oldPageSize = this.pageSize
        // 回到第一行
        this.$refs.kuwoTable.bodyWrapper.scrollTop = 0;
      }).catch(err => {
        console.log(err)
        this.$message.error(err)
        this.searchLoading = false
        // 请求失败后同步备份
        this.currentPage = this.oldPage
        this.pageSize = this.oldPageSize
      })
    },
    // 酷狗搜索
    searchFromKugou() {
      // 这里使用封装的axios，所以这里的/api不写
      searchMusic({
        'keyword':this.searchForm.keyword,
        'platId': this.platId,
        'pageNum': this.currentPage,
        'pageSize':this.pageSize
      }).then(res => {
        if (res.status !== ResponseCode.success) {
          this.$message.error('请求失败！'+res.statusText)
          this.searchLoading = false
          // 请求失败后同步备份
          this.currentPage = this.oldPage
          this.pageSize = this.oldPageSize
          return
        }
        if (res.data.status !== 1) {
          this.$message.error('数据源错误！'+ res.data.error_msg)
          // 请求失败后同步备份
          this.currentPage = this.oldPage
          this.pageSize = this.oldPageSize
          this.searchLoading = false
          return
        }
        // this.$message.success('查询成功')
        this.$notify.success('查询成功')
        this.total = parseInt(res.data.data.total)
        this.kugouTableData = res.data.data.lists
        this.searchLoading = false
        // 请求成功后同步备份
        this.oldPage = this.currentPage
        this.oldPageSize = this.pageSize
        // 回到第一行
        this.$refs.kugouTable.bodyWrapper.scrollTop = 0;
      }).catch(err => {
        console.log(err)
        this.$message.error(err)
        this.searchLoading = false
        // 请求失败后同步备份
        this.currentPage = this.oldPage
        this.pageSize = this.oldPageSize
      })
    },
    // bilibili搜索
    searchFromBilibili() {

    },
    onSearch() {
      if (this.searchForm.keyword === '') {
        this.$message.warning('查询关键词不能为空')
        return
      }
      this.searchLoading = true
      if (this.platId === this.platIds.kuwo) {
        this.searchFromKuwo()
      } else if (this.platId === this.platIds.kugou) {
        this.searchFromKugou()
      } else if (this.platId === this.platIds.bilibili) {
        this.searchFromBilibili()
      }
    },

    // 分页
    handleSizeChange: function (val) {
      // console.log(`每页 ${val} 条`);
      this.pageSize = val
      // 更改页大小后，从第一页开始
      this.currentPage = 1
      this.onSearch()
    },
    handleCurrentChange: function (val) {
      // console.log(`当前页: ${val}`);
      this.currentPage = val
      this.onSearch()
    },

    // 选中表格数据
    handleSelectionChange(selection) {
      this.selection = selection
    },

    // 打开添加歌单弹窗
    openCollectionDialog() {
      // 打开弹窗
      this.collectionDialogVisible = true;
      this.collectionLoading = true
      // 判断本地是否有歌单数据
      const localCollectionOption = this.musicStore.collectionList
      if (localCollectionOption) {
        this.collectionOption = localCollectionOption
        this.collectionForm['id'] = this.collectionOption[0].id
        this.collectionLoading = false
        return
      }
      // 本地没有，请求歌单数据
      getCollection().then(res=>{
        const data = res.data
        if (data.success) {
          if (data.data.length > 0) {
            this.collectionOption = data.data
            this.collectionForm['id'] = this.collectionOption[0].id
            // 保存到本地
            this.musicCommit(this.collectionOption)
          }
        }
        this.collectionLoading = false
      })
    },

    // 创建歌单
    createCollection() {
      this.collectionLoading = true
      // 准备歌单对象
      const songInfo = {
        name: this.collectionForm.name,
        description: this.collectionForm.description
      }
      // 发请求创建歌单
      addCollection(songInfo).then(res=>{
        const data = res.data
        if (!data.success) {
          this.$message.error(data.msg)
          return
        }
        // this.$message.success(data.msg)
        this.$notify.success(data.msg)
        // 添加成功后会返回id
        const newCollectionItem = {
          id: data.data,
          name: this.collectionForm.name,
          description: this.collectionForm.description
        }
        // 更新选择框显示
        this.collectionForm.name = ''
        this.collectionForm.description = ''
        this.collectionOption.push(newCollectionItem)
        this.collectionForm.id = newCollectionItem.id
        this.collectionLoading = false
        // 将选择数据保存到本地，下次直接从本地取
        this.musicCommit(this.collectionOption)
      })

    },

    // 关闭歌单弹窗
    closeCollectionDialog() {
      this.collectionDialogVisible = false
      this.collectionLoading = false
      this.collectionForm.id = this.collectionOption.length > 0 ? this.collectionOption[0].id : -1
    },

    // 添加到播放列表
    async addToPlayList(row) {
      const musicItem = await this.convert(this.platId, row)
      this.$store.commit('music/addPlayListItem', musicItem)
      this.$notify.success('已添加到播放列表')
    },

    // 将选中数据添加到歌单
    async submitAddToCollection() {
      /**
       * 1 转换得到音频地址，创建MusicItem对象
       * 2 添加到本地歌单中，即添加到musicList中
       * 3 发送到后端
       *  3.1 发送后端时，需要弹窗选择加入哪个歌单，没有歌单则需要创建（或者有一个默认歌单）
       */
      this.collectionLoading = true
      let songInfoList = []
      for (const row of this.selection) {
        const musicItem = await this.convert(this.platId, row)
        if (musicItem.src === 'unknown') {
          this.collectionLoading = false
          // 关闭弹窗
          this.closeCollectionDialog()
          return
        }
        // 转换 播放器item 到 数据库songInfo
        const songInfoItem = this.convertMusicItemToSongInfo(musicItem);
        songInfoList.push(songInfoItem)
      }
      // 发送请求，将数据发送到后端
      await addSongInfo(songInfoList).then(res=>{
        const data = res.data
        if (!data.success) {
          this.$message.error(data.msg)
          return
        }
        // 如果有data，说明有部分是没有添加成功的
        if (data.data) {
          // this.$message.warning('部分添加成功！未添加成功的数据请看控制台')
          this.$notify.warning('部分添加成功！未添加成功的数据请看控制台')
        } else {
          // this.$message.success(data.msg)
          this.$notify.success(data.msg)
        }
      })

      // 等待响应成功，关闭弹窗
      this.closeCollectionDialog()
    },

    /*
    * 将播放器的 播放对象 musicItem 转为 数据库 SongInfo 对象
    * */
    convertMusicItemToSongInfo(item) {
      return {
        collectionId: this.collectionForm.id,
        songId: item.audioId,
        songName: item.title,
        singerName: item.artist,
        albumName: item.album,
        playUrl: item.src,
        quality: item.quality,
        imgUrl: item.pic,
        lyrics: item.lrc,
        platId: this.platId,
        sourceUrl: ''
      }
    },

    /**
     * 播放
     */
    // TODO 播放时也要根据不同平台来处理
    async playFromKuwo(row) {
      this.albumUrl = row.albumpic
      this.playTitle = row.name + '-' + row.artist
      // 使用await 等待convert执行完返回结果后再继续往下走，同时本方法需要添加async修饰
      await this.convert(this.platId, row)
      // 这里需要等待convert返回结果后才能操作，否则空对象异常
      // const audio= document.getElementById("playing");
      // //播放(继续播放)
      // audio.play();
      // //暂停
      // audio.pause();
      // //停止
      // audio.pause();
      // audio.currentTime = 0;
      // //重新播放
      // audio.currentTime = 0;
      // audio.play();
    },
    async playFromKugou(row) {
      this.albumUrl = row.Image.replace('{size}/', '')
      this.playTitle = row.SongName + '-' + row.SingerName
      // 使用await 等待convert执行完返回结果后再继续往下走，同时本方法需要添加async修饰
      const musicItem = await this.convert(this.platId, row)

      // 使用全局事件总线传数据到播放组件
      this.$bus.$emit('playMusic', musicItem)
    },

    /**
     * 跳转到源地址
     */
    showSource(row) {
      let url;
      if (this.platId === this.platIds.kuwo) {
        url = "https://www.kuwo.cn/play_detail/" + row.rid;
      } else if (this.platId === this.platIds.kugou) {
        url = "";
      } else if (this.platId === this.platIds.bilibili) {
        url = "";
      }
      window.open(url);
    },

    /**
     * 下载
     */
    // TODO 不同平台下载也要对参数做处理
    async downloadFromKuwo(row) {
      // console.log(row)
      const {src} = await this.convert(this.platId, row)
      download(src, row.name+'_'+row.artist, 'mp3', ()=>{
        this.downloadDialogVisible = true;
      })
    },
    async downloadFromKugou(row) {
      const {src} = await this.convert(this.platId, row)
      download(src, row.SongName+'_'+row.SingerName, 'mp3', ()=>{
        this.downloadDialogVisible = true;
      })
    },

    /*
     * 转换得到真实文件地址
     * 返回一个vueAplayer播放器 music对象
     */
    convert(platId, row) {
      // 酷我
      if (platId === this.platIds.kuwo) {
        // 直接返回异步结果
        return convertMusic({
          platId: platId,
          id: row.rid
        }).then(res => {
          // console.log(res)
          if (res.status !== ResponseCode.success) {
            this.$message.error('请求失败！' + res.statusText)
            return
          }
          if (res.data.code !== ResponseCode.success) {
            this.$message.error('数据源错误！' + res.data.message)
            return
          }
          if (res.data.data) {
            return Promise.resolve(res.data.data);
          }
        }).catch(err => {
          console.log(err)
          this.$message.error(err)
        });
      } else if (platId === this.platIds.kugou) {
        // 酷狗  可以选择音质
        const emptyItem = {
          src: 'unknown'
        }
        // 拼接音频文件hash
        const fileHash = this.kugouQualityPrefix + 'FileHash'
        const hash = row[fileHash]
        // 选择了不存在的音质
        if(!hash) {
          this.$message.error('没有'+this.kugouQualityPrefix+'音质的文件！')
          return emptyItem
        }
        return convertMusic({
          platId: platId,
          hash: hash,
          albumId: row.AlbumID
        }).then(res => {
          if (res.status !== ResponseCode.success) {
            this.$message.error('请求失败！' + res.statusText)
            return emptyItem
          }
          if (res.data.status !== 1) {
            this.$message.error('数据源错误！' + res.data.err_msg)
            return emptyItem
          }
          if (res.data.data) {
            const data = res.data.data

            this.audioId = data.audio_id
            this.albumUrl = data.img
            this.mp3Url = data.play_url
            this.lyrics = data.lyrics
            this.playTitle = row.OriSongName + row.Suffix + '_' + row.SingerName;

            // 返回vueAplayer播放器的数据
            const musicItem = {
              audioId: data.audio_id,
              title:  row.OriSongName + row.Suffix,
              artist: row.SingerName,
              src: data.play_url,
              pic: data.img,
              lrc: data.lyrics,
              album: row.AlbumName,
              quality: this.kugouQualityPrefix ? this.kugouQualityPrefix : 'normal'
            }
            // return musicItem;
            return Promise.resolve(musicItem);
          }
        }).catch(err => {
          console.log(err)
          this.$message.error(err)
        });
      } else if (platId === this.platIds.bilibili) {
        // bilibili
        return convertMusic({
          id: row.rid
        }).then(res => {
          // console.log(res)
          if (res.status !== ResponseCode.success) {
            this.$message.error('请求失败！' + res.statusText)
            return
          }
          if (res.data.code !== ResponseCode.success) {
            this.$message.error('数据源错误！' + res.data.message)
            return
          }
          if (res.data.data) {
            return Promise.resolve(res.data.data);
          }
        }).catch(err => {
          console.log(err)
          this.$message.error(err)
        });
      }
    },

    // 酷我
    convertFromKuwo() {

    },
    // 酷狗
    convertFromKugou() {

    },
    // Bilibili
    convertFromBilibili() {

    },

    // 设置store中的配置
    musicCommit(collectionOption) {
      this.$store.commit('music/setCollectionList', collectionOption)
    },
  },

  mounted() {

    setTimeout(()=>{
      // 等待后台返回平台列表数据后，再去获取
      const item = this.$store.state.music.platInfoList.find(item => item.def === 1)
      if (item) {
        this.platId = item.id;
      }
    }, 100);
  },

  computed: {
    musicStore() {
      return this.$store.state.music
    },
    platIds() {
      return this.$store.state.music.platIds
    },
  },
  beforeDestroy() {
  }
}
</script>

<style lang="less" scoped>
.container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  background: white;
  .toolbar {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin: 5px;
  }

  // 设置分割线样式
  /deep/.el-divider--horizontal {
    margin: 0;
  }

  .table {
    flex: 1;
    position: relative;
    /deep/.el-table {
      position: absolute;
    }
  }
  .table-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 5px 0;
  }
}

.el-form-item {
  margin-bottom: 0;
}

.playInfo {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

// 可以将内容撑满屏幕
/*//.el-card {
//  height: 100%;
//
//  .table {
//    flex: 1;
//    position: relative;
//    /deep/.el-table {
//      position: absolute;
//    }
//  }
//  /deep/.el-card__body {
//    display: flex;
//    flex-direction: column;
//    justify-content: space-between;
//    height: 100%;
//    padding: 5px 5px 0 5px;
//  }
//}*/
</style>
